import { rootUrl } from '@/constants';
import { getCookies } from '@/utils/cookie';
import axios from 'axios';

export type SubmitGetDaybookList = {
  user: string;
  offset: number;
};

export type DaybookType = 'standard' | 'dream' | 'gratitude' | 'question' | string;

export type Daybook = {
  id: string;
  text?: string;
  textBin?: string;
  typeDaybook?: DaybookType;
  creationDate: string;
};

export type ResponseGetDaybookList = Daybook[];

export const getDaybookList = async (data: SubmitGetDaybookList) => {
  const response = await axios.get(`${rootUrl}/psychologist/daybook/list`, {
    params: {
      user: data.user,
      offset: data.offset,
      token: getCookies('auth'),
    },
    headers: {
      'Cache-Control': 'no-store',
    },
  });

  return response.data;
};
